import { useEffect, useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { fetchAccountNames, updateAccountNames } from "@/services/userApi";
import { INPUT_CLASS } from "../types/settings.types";

export default function AccountNamesCard() {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function loadNames() {
      try {
        const names = await fetchAccountNames();
        setValue(names.join("\n"));
      } catch {
        toast.error("Failed to load account holder names");
      } finally {
        setLoading(false);
      }
    }
    void loadNames();
  }, []);

  async function handleSave() {
    setSaving(true);
    try {
      const names = await updateAccountNames(
        value
          .split("\n")
          .map((n) => n.trim())
          .filter(Boolean),
      );
      setValue(names.join("\n"));
      toast.success("Account holder names saved");
    } catch {
      toast.error("Failed to save account holder names");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Card className="mt-6">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <ArrowLeftRight className="w-4 h-4" />
          Account Holder Names
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-muted-foreground">
          One name per line (Thai and English). When both the sender and the
          receiver match these names, the transaction is marked as a Transfer
          and excluded from spending.
        </p>
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={loading || saving}
          rows={3}
          placeholder={"ชื่อ นามสกุล\nFirstname Lastname"}
          className={`${INPUT_CLASS} w-full resize-y`}
        />
        <Button
          size="sm"
          onClick={handleSave}
          disabled={loading}
          loading={saving}
        >
          {saving ? "Saving…" : "Save"}
        </Button>
      </CardContent>
    </Card>
  );
}
